import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { Section } from '@/components/Section';

export function AboutHero() {
  return (
    <Section>
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm text-primary font-medium uppercase tracking-widest mb-4 block">About</span>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-testid="about-headline">
            Robert Brunet
          </h1>
          <p className="text-xl text-muted-foreground leading-relaxed mb-4">
            Technology systems architect, entrepreneur, and author who designs practical systems that help people and organizations harness emerging technologies.
          </p>
          <p className="text-muted-foreground leading-relaxed mb-6">
            Not a theorist. A builder and operator with 40+ years of experience turning complex technology into working systems.
          </p>
          <div className="flex items-center gap-2 text-muted-foreground">
            <MapPin className="w-5 h-5 text-primary" />
            <span>Colorado Springs, Colorado</span>
          </div>
        </motion.div>
        
        <motion.div
          className="relative max-w-[50%] mx-auto"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-card border border-border">
            <img
              src="https://customer-assets.emergentagent.com/job_ef2cf11f-b6e4-4f26-a2ce-11457061709c/artifacts/bb152ezg_R_Dale_Brunet_AI_Headshot_4.png"
              alt="R. Dale Brunet professional portrait"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </motion.div>
      </div>
    </Section>
  );
}
